// extracted by mini-css-extract-plugin
module.exports = {"auth-layout":"AuthLayout_auth-layout__3sgrP","auth-wrapper":"AuthLayout_auth-wrapper__3Ewaj","auth-title":"AuthLayout_auth-title__1BF0z","auth-logo":"AuthLayout_auth-logo__2jmNG"};